// extracted by mini-css-extract-plugin
module.exports = {"signInButton":"userProfile_signInButton__PXL9P","signInLabel":"userProfile_signInLabel__hOFV_"};